module.exports = __webpack_public_path__ + "media/images/sm_icon01-aba83fffccbe10e61f92c8d34aebd336.png";